module.exports = __webpack_public_path__ + "images/emoji/aquarius.580aab93a81fed40a527.png";